import { render, staticRenderFns } from "./SetType.vue?vue&type=template&id=05665db2&scoped=true"
import script from "./SetType.vue?vue&type=script&lang=js"
export * from "./SetType.vue?vue&type=script&lang=js"
import style0 from "./SetType.vue?vue&type=style&index=0&id=05665db2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05665db2",
  null
  
)

export default component.exports